import { render, staticRenderFns } from "./OrderSplitPayment.vue?vue&type=template&id=30bfc66a"
import script from "./OrderSplitPayment.vue?vue&type=script&lang=js"
export * from "./OrderSplitPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports